@if (isLoading){
  <section class="loading">
    <p-skeleton width="14rem" height="2.5rem" />
    <p-skeleton height="8rem" />
  </section>
} @else {
  <form [formGroup]="formGroup">
    @if (mode !== 'view' && triggers.controls.length > 0) {
      <div class="create">
        <app-button-icon label="common.actions.add-alarm-rule-trigger"
                         [isTranslated]="true"
                         iconName="add"
                         (click)="createTriggerOnClick()" />
      </div>
    }

    @if (triggers.controls.length) {
      <div class="list" formArrayName="triggers">
        @for (trigger of triggers.controls; track $index; let i = $index) {
          <div class="card" [formGroupName]="i">
            <div class="content">
              <span class="title">
                <span class="material-symbols-rounded upload-icon">
                  {{ getIcon(i) }}
                </span>
                {{ getName(i) | translateSafe }}
              </span>

              @if (getTriggerType(i); as triggerType) {
                <ng-container
                  *ngComponentOutlet="
                    this.getDefinition(triggerType).getEditorComponent();
                    inputs: {
                      formGroup: trigger
                    }
                  ">
                </ng-container>
              }
            </div>

            @if (mode !== 'view') {
              <app-button-icon
                class="red"
                iconName="delete"
                (click)="removeTrigger($index)" />
            }
          </div>
        }
      </div>
    } @else {
      <div class="empty-triggers">
        <span class="material-symbols-rounded red">
          error
        </span>

        @if (mode == 'view') {
          <span>
            {{ 'common.alarm-rule.trigger.view.empty-message' | translateSafe }}
          </span>
        } @else {
          <span>
            {{ 'common.alarm-rule.trigger.edit.empty-message' | translateSafe }}
          </span>
          <app-button-icon label="common.actions.add-alarm-rule-trigger"
                           [isTranslated]="true"
                           iconName="add"
                           (click)="createTriggerOnClick()" />
        }
      </div>
    }
  </form>

  <app-dialog-base [class.open]="addDialogOpen"
                   iconLeft="add_diamond"
                   [buttonAction]="() => addDialogOpen = false"
                   (outSideClick)="addDialogOpen = false"
                   title="{{ 'dialogs.alarm-rule.add-trigger' | translateSafe }}">

    <app-input-item-selection [formData]="TypeSelect"
                              (selectedOption)="onTypeSelect($event)"
    />
  </app-dialog-base>
}